import { createStore, StateMachineProvider } from 'little-state-machine';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchRoster } from '../../../Redux/slices/rosters';

import Layout from './Steps/Organization/Component/Layout';
createStore({});

function Organization() {
  const dispatch = useDispatch();
  const { id, edit: isEdit } = useParams();
  useEffect(() => {
    if (isEdit) {
      dispatch(fetchRoster(`/profile/resource-person/${id}/`));
    }
  }, []);
  return (
    <StateMachineProvider>
      <Layout />
    </StateMachineProvider>
  );
}

export default Organization;
